import { EntityRepository } from 'root/lsCloud/EntityRepository/EntityRepository';

export class OptionRepository extends EntityRepository {
  constructor() {
    super('Option');
  }

  get(
    optionNames: string | string[],
    options: { reload?: boolean } = {}
  ): JQuery.Deferred<any | undefined> {
    const deferred = $.Deferred();
    this.getAll(options)
      .then((options) => {
        const names = Array.isArray(optionNames) ? optionNames : [optionNames];
        const values = names.map((name) => {
          const option = options.find((option) => option.name === name);
          return option ? option.value : undefined;
        });
        deferred.resolve(Array.isArray(optionNames) ? values : values[0]);
      })
      .catch((error) => {
        console.warn('Failed to get options:', error);
        deferred.reject(error);
      });
    return deferred;
  }

  save(optionName: string, optionValue: any): JQuery.Deferred<void> {
    const deferred = $.Deferred();
    let cached: boolean = false;

    if (this.entities !== null) {
      cached = this.entities.some((entity, index) => {
        if (entity.name === optionName) {
          this.entities![index].value = optionValue;
          return true;
        }
        return false;
      });
    }
    try {
      const url: string = this.getPath();
      const obj = { Options: [{ name: optionName, value: optionValue }] };
      const job: LSCloudServerJob = { url, obj };
      window.lsCloud
        .startServerJob(job)
        .done((response) => {
          if (this.entities && !cached) {
            this.entities.push(response.Option);
          }
          deferred.resolve();
        })
        .fail((error) => deferred.reject(error));
    } catch (error) {
      deferred.reject(error);
    }
    return deferred;
  }

  async bulkSave(options: { name: string; value: any }[]): Promise<void> {
    if (options.length === 0) {
      return;
    }
    try {
      const url: string = this.getPath();
      const obj = { Options: options };
      const job: LSCloudServerJob = { url, obj };
      await window.lsCloud.startServerJob(job).promise();

      if (this.entities !== null) {
        options.forEach((option) => {
          const index = this.entities!.findIndex((entity) => entity.name === option.name);
          if (index !== -1) {
            this.entities![index].value = option.value;
          } else {
            this.entities!.push({ name: option.name, value: option.value });
          }
        });
      }
    } catch (error) {
      throw error;
    }
  }
}
